import workerDataSlice from './slice';

export { default as initialState } from './state';

export type { IWorkerDataState, IContact } from './state';

export {
  fetchConsentFormInformation,
  downloadConsentFormPdf,
  fetchMyCertifications,
  fetchRequiredCertifications,
  fetchWorkerDrugTestingSchedules,
  createWorkerDrugTestingSchedule,
  updateWorkerDrugTestingSchedule,
  deleteWorkerDrugTestingSchedule,
  fetchWorkerThirdPartyDrugTestResults,
  createWorkerThirdPartyDrugTestResult,
  updateWorkerThirdPartyDrugTestResult,
  deleteWorkerThirdPartyDrugTestResult,
  addMyCertification,
  updateMyCertification,
  deleteMyCertification,
  fetchWorkerCourses,
  fetchWorkerProjects,
  fetchEmailContacts,
  fetchPhoneContacts,
  addContact,
  removeContact,
  makePrimaryContact,
  verifyContact,
  fetchProfileCustomFieldsConfig,
  fetchWorkerCompaniesRequirements,
} from './actions';

export const { resetWorkerData, resetWorkerProjects, resetAdminContacts } = workerDataSlice.actions;

export default workerDataSlice.reducer;
